import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TikTokFilledSvg from "@ant-design/icons-svg/es/asn/TikTokFilled";
import AntdIcon from "../components/AntdIcon";
var TikTokFilled = function TikTokFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TikTokFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TikTokFilled.displayName = 'TikTokFilled';
}
export default /*#__PURE__*/React.forwardRef(TikTokFilled);